import { useEffect, useState } from "react";
import { Save, Type } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";

const GROUP_TR = {
    hero: "Ana Vitrin (Hero)",
    categories: "Kategoriler Bölümü",
    features: "Özellik Kartları",
    join: "Katılım Bölümü (Kayıt Kartları)",
    footer: "Footer",
    site: "Site Ayarları",
};

const isLong = (key) => key.endsWith("_desc") || key.endsWith("_subtitle") || key.endsWith("_about");

export default function ContentTab() {
    const [blocks, setBlocks] = useState(null);
    const [edits, setEdits] = useState({});
    const [saving, setSaving] = useState(false);

    const load = () => api.get("/admin/content").then((r) => setBlocks(r.data)).catch(() => {});
    useEffect(() => { load(); }, []);

    const save = async () => {
        if (!Object.keys(edits).length) return toast.error("Değişiklik yok");
        setSaving(true);
        try {
            const r = await api.put("/admin/content", { updates: edits });
            toast.success(`${r.data.updated} metin güncellendi — ana sayfada anında yayında`);
            setEdits({});
            load();
        } catch (e) {
            toast.error(e.response?.data?.detail || "Kaydedilemedi");
        } finally {
            setSaving(false);
        }
    };

    if (!blocks) return <div className="space-y-3">{[...Array(4)].map((_, i) => <div key={i} className="h-16 animate-pulse rounded-2xl bg-muted" />)}</div>;

    const groups = {};
    for (const b of blocks) {
        groups[b.group] = groups[b.group] || [];
        groups[b.group].push(b);
    }

    return (
        <div className="space-y-6" data-testid="content-tab">
            <div className="flex flex-wrap items-center justify-between gap-3">
                <p className="text-sm text-muted-foreground">
                    Ana sayfadaki tüm metinleri buradan düzenleyin. Kaydettiğinizde değişiklik anında yayına alınır.
                </p>
                <Button onClick={save} disabled={saving || !Object.keys(edits).length} className="bg-terra-600 hover:bg-terra-700 text-white" data-testid="content-save-button">
                    <Save className="mr-2 h-4 w-4" /> {saving ? "Kaydediliyor..." : `Değişiklikleri Yayınla${Object.keys(edits).length ? ` (${Object.keys(edits).length})` : ""}`}
                </Button>
            </div>

            {Object.entries(groups).map(([g, items]) => (
                <div key={g} className="rounded-2xl border bg-card p-5 shadow-sm" data-testid={`content-group-${g}`}>
                    <div className="mb-4 flex items-center gap-2">
                        <Type className="h-4 w-4 text-terra-600" />
                        <h3 className="font-display font-bold">{GROUP_TR[g] || g}</h3>
                    </div>
                    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
                        {items.map((b) => (
                            <div key={b.key}>
                                <p className="mb-1 text-xs font-medium text-muted-foreground">{b.label} <span className="opacity-50">({b.key})</span></p>
                                {isLong(b.key) ? (
                                    <Textarea
                                        rows={2}
                                        value={edits[b.key] ?? b.value}
                                        onChange={(e) => setEdits({ ...edits, [b.key]: e.target.value })}
                                        data-testid={`content-input-${b.key}`}
                                    />
                                ) : (
                                    <Input
                                        value={edits[b.key] ?? b.value}
                                        onChange={(e) => setEdits({ ...edits, [b.key]: e.target.value })}
                                        data-testid={`content-input-${b.key}`}
                                    />
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
}
